import React, { useEffect, useState } from 'react'
import { CFormInput } from '@coreui/react-pro'

const ConfiaCarInput = (props) => {
  const { children, error } = props
  const [errorLabel, setErrorLabel] = useState('')
  const [isValid, setIsValid] = useState(true)
  useEffect(() => {
    if (error?.message) {
      setErrorLabel(error.message)
    } else {
      setErrorLabel('')
    }
  }, [error])

  useEffect(() => {
    if (errorLabel.length) {
      setIsValid(false)
    } else {
      setIsValid(true)
    }
  }, [errorLabel])
  return (
    <>
      <CFormInput feedback={errorLabel} invalid={!isValid} {...props}>
        {children}
      </CFormInput>
    </>
  )
}

export { ConfiaCarInput }
